/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the DLS icon for a geofence icon. Used in searches, etc.
 */
export const GeofenceTypeIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M12.4411 3.8335L3.99902 12.0705V17.8144L18.3242 3.8335H12.4411Z'
        fill={iconColor} />
      <path d='M10.1796 3.8335H5.02768C4.75486 3.8335 4.49321 3.93736 4.30029 4.12224C4.10738 4.30712 3.99902 4.55789 3.99902 4.81934V9.86254L10.1796 3.8335Z'
        fill={iconColor} />
      <path d='M19.9992 10.1558V4.81925C19.9988 4.70213 19.9758 4.58609 19.9312 4.47705L4.90039 19.1423C4.94276 19.1469 4.98551 19.1469 5.02788 19.1423H10.7579L19.9992 10.1558Z'
        fill={iconColor} />
      <path d='M13.0278 19.1668H18.9789C19.2495 19.1668 19.509 19.0638 19.7003 18.8805C19.8916 18.6971 19.9991 18.4484 19.9991 18.1891V12.3638L13.0278 19.1668Z'
        fill={iconColor} />
    </svg>
  );
};
GeofenceTypeIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey4
};
